export default __webpack_public_path__ + "static/media/classCompChild.201d4cfe.png";